export default __webpack_public_path__ + "static/media/Tanzania.301e6392.png";